module.exports = __webpack_public_path__ + "static/media/account_balance_wallet.26f03bc6.svg";